import { FC, useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { PuffLoader } from 'react-spinners';
import { Icons } from '@assets';
import { OriginsLineChart } from './ui/originsLineChart';
import { useDispatch, useSelector } from 'react-redux';
import { authInfoSelect } from '@entities/auth';
import {
    API_DATE_FORMAT,
    cssOverride,
    DISPLAY_DATE_FORMAT,
} from '@utils/const';
import * as S from './styles';
import { RangePickerProps } from 'antd/es/date-picker';
import { AppDispatch } from '@config/store';
import { appSelect, resetDateRange, setDateRange } from '@entities/app';
import { getSources } from '@api/thunks/reports';
import { reportsSelect } from '@entities/reports';
import { SourcesTable } from './ui/sourcesTable';
import { colors } from '@styles';

const SourcesPage: FC = () => {
    const { shop } = useSelector(authInfoSelect);
    const { from, to } = useSelector(appSelect).dateRange;
    const { sources, loading } = useSelector(reportsSelect);

    const [selectValue, setSelectValue] = useState<string>('');
    const [values, setValues] = useState<{ value: string; label: string }[]>(
        []
    );

    const dispatch = useDispatch<AppDispatch>();

    const onDateChange: RangePickerProps['onChange'] = (date, dateStrings) => {
        if (!dateStrings[0] && !dateStrings[1] && !date) {
            dispatch(resetDateRange());
            return;
        }

        dispatch(
            setDateRange({
                from: dayjs(dateStrings[0], DISPLAY_DATE_FORMAT).format(
                    API_DATE_FORMAT
                ),

                to: dayjs(dateStrings[1], DISPLAY_DATE_FORMAT).format(
                    API_DATE_FORMAT
                ),
            })
        );
    };

    const handleChange = (value: unknown) => {
        setSelectValue(value as string);
    };

    useEffect(() => {
        if (sources?.charts) {
            const options = Object.keys(sources?.charts).map(item => ({
                value: item,
                label: item,
            }));
            setValues(options);
            setSelectValue(options[0].value);
        }
    }, [sources]);

    useEffect(() => {
        const params = { from, to };
        if (shop) {
            dispatch(getSources({ shop_id: shop.id, params }));
        }
    }, [shop, dispatch, from, to]);

    return (
        <S.Wrapper>
            <S.Header>
                <S.StyledHeadTitle>Источники</S.StyledHeadTitle>
                <S.StyledCalendarWrapper>
                    <S.StyledRangePicker
                        suffixIcon={
                            <img
                                src={Icons.IconMainCalendar}
                                alt="icon calendar"
                            />
                        }
                        onChange={onDateChange}
                        value={[
                            dayjs(from, API_DATE_FORMAT),
                            dayjs(to, API_DATE_FORMAT),
                        ]}
                        format={DISPLAY_DATE_FORMAT}
                    />
                </S.StyledCalendarWrapper>
            </S.Header>
            {loading === 'loading' ? (
                <PuffLoader color={colors.loader} cssOverride={cssOverride} />
            ) : (
                <div>
                    {sources?.charts && selectValue && (
                        <S.ChartsWrapper>
                            <S.StyledSelect
                                value={selectValue}
                                onChange={handleChange}
                                options={values}
                            />

                            <OriginsLineChart
                                chartData={sources?.charts[selectValue]}
                            />
                        </S.ChartsWrapper>
                    )}
                    {sources && <SourcesTable />}
                </div>
            )}
        </S.Wrapper>
    );
};

export default SourcesPage;
